<template>
	<div>
		<form-sidebar>
			<v-form>
				<v-layout wrap align-start>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							:height="48"
							hide-details
							label="Código Contable"
							type="number"
							v-model="code"
							disabled
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							:height="48"
							hide-details
							label="Cuenta Contable"
							v-model="model.account"
							disabled
						></v-text-field>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							:height="48"
							hide-details
							label="Nombre"
							v-model="model.name"
						></v-text-field>
					</v-flex>
					<v-flex xs12 my-2 v-if="status === 1">
						<v-checkbox
							class=" ma-0 justify-start check-table"
							color="success"
							hide-details
							label="Cuenta Auxiliar"
							v-model="model.auxCont"
						></v-checkbox>
					</v-flex>
					<v-flex xs12 v-if="mode !== 'edit'">
						<v-switch
							v-model="model.flagFather"
							label="Cuenta Padre"
							color="success"
							class="align-center my-0 pt-0 accounting-switch-normal"
							hide-details
						/>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						success-text="Aceptar"
						@cancel-button-clicked="$emit('on-close')"
						@accept-button-clicked="submitForm"
						:is-loading="disabled || loading"
					></modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { integer, numeric, required } from 'vuelidate/lib/validators';

function created() {
	this.mode = this.$route.name.indexOf('edit') > -1 ? 'edit' : 'create';
	this.loadAccount();
}

function disabled() {
	return this.$v.$invalid || this.loading;
}

async function loadAccount() {
	try {
		const { data: record } = await this.$http.get(
			`com-accounting-accounts-details/${this.id}`);
		if (this.mode === 'edit') {
			const account = record.account.split('.');
			this.code = this.mode === 'edit' ? record.code : account.pop();
			this.accountingAccount = this.mode === 'edit' ? `${record.accountingPlanId}.` :
				`${account.join('.')}.`;
			this.model.code = record.code;
			this.model.account = record.account;
			this.model.name = record.name;
			this.model.auxCont = record.auxCont === 1;
			this.model.flagFather = record.flagParent === 1;
			this.status = record.status;
			/* esta variable sirve para el this.accountingAccount si es ser necesario
			accountingAccountCode */
		} else {
			this.validAccount(record);
		}
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function setAccountData(value) {
	const code = this.accountingAccount.replace(/\./g, '');
	const accountSplit = this.accountingAccount.split('.');
	if (accountSplit.indexOf('') > -1) {
		accountSplit.splice(accountSplit.indexOf(''), 1);
	}
	const newAccount = accountSplit.join('.');
	this.code = value;
	this.model.code = code.concat(value);
	this.model.account = newAccount.concat(`.${value}`);
}

async function submitForm() {
	this.loading = true;
	const method = this.mode === 'edit' ? 'patch' : 'post';
	const baseUrl = 'com-accounting-accounts';
	const url = this.mode === 'edit' ? `${baseUrl}/${this.id}` :
		`${baseUrl}/${this.planId}`;
	const action = this.mode === 'edit' ? 'actualizada' : 'creada';
	if (this.mode !== 'edit') {
		delete this.model.auxCont;
	} else {
		delete this.model.flagFather;
	}
	try {
		await this.$http[method](url, this.model);
		this.showNotification(`La cuenta ha sido ${action} correctamente`);
		this.$emit('on-close');
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			if (err.data.message === 'ACCOUNTING_ACCOUNT_EXIST') {
				this.showGenericError('La cuenta ya existe.');
			} else if (err.data.message === 'ACCOUNTING_ACCOUNT_FATHER_NOT_FOUND') {
				this.showGenericError('El padre de la cuenta contable no existe.');
			}
		}
	} finally {
		this.loading = false;
	}
}

function validAccount({ account }) {
	const lastIndexPoint = account.lastIndexOf('.');
	const invalid = lastIndexPoint === (account.length - 1);
	this.accountingAccount = invalid ? account : `${account}.`;
}

function validations() {
	return {
		code: { required },
		model: {
			account: { required },
			code: { required, numeric, integer },
			name: { required },
		},
	};
}

function data() {
	return {
		accountingAccount: null,
		code: null,
		loading: false,
		model: {
			account: null,
			code: null,
			name: null,
			auxCont: false,
			flagFather: false,
		},
		status: null,
	};
}

export default {
	name: 'accounting-account-form',
	computed: {
		disabled,
	},
	created,
	data,
	methods: {
		loadAccount,
		setAccountData,
		submitForm,
		validAccount,
	},
	props: {
		planId: [Number, String],
		id: [Number, String],
		route: {
			default: 'accounting-account',
			type: String,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/accounting-accounts/accounting-account-form.vue